var map = {
	"./social-500px.svg": 345,
	"./social-dribbble.svg": 346,
	"./social-facebook.svg": 347,
	"./social-github.svg": 348,
	"./social-google.svg": 349,
	"./social-instagram.svg": 350,
	"./social-odnoklassniki.svg": 351,
	"./social-reddit.svg": 352,
	"./social-stackoverflow.svg": 353,
	"./social-steam.svg": 354,
	"./social-twitch.svg": 355,
	"./social-twitter.svg": 356,
	"./social-vkontakte.svg": 357,
	"./social-windows.svg": 358,
	"./social-wordpress.svg": 359,
	"./social-yahoo.svg": 360
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 344;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth ^\.\/social\-.*\.svg$
// module id = 344
// module chunks = 0